import { IExpert, RejectionCodesMap } from '@techspert-io/experts';

export enum CallSolicitationOutcomeMap {
  CallFailed = 'call-failed',
  NoAnswer = 'no-answer',
  WrongNumber = 'wrong-number',
  ExpertRejection = 'expert-rejection',
  AdminRejection = 'admin-rejection',
  Accepted = 'accepted',
}

export interface ICallSolicitation {
  call_solicitation_id: string;
  recipient_number: string;
  expert_id: string;
  call_datetime: string;
  caller_connect_id: string;
  caller_microsoft_id: string;
  outcome: CallSolicitationOutcomeMap | null;
  notes: string | null;
  /** The duration of the call in seconds as provided by the Graph API callback - if null can assume callback not received yet */
  duration_seconds: number | null;
  /** postgresql timestamp  */
  created_at: string;
  /** uuid */
  created_by: string;
  /** postgresql timestamp  */
  updated_at: string;
  /** uuid */
  updated_by: string;
}

export type ICallSolicitationCreate = Omit<
  ICallSolicitation,
  | 'call_solicitation_id'
  | 'caller_microsoft_id'
  | 'created_at'
  | 'created_by'
  | 'updated_at'
  | 'updated_by'
  | 'call_datetime'
> & {
  call_solicitation_id?: string;
  /** ISO 8601 timestamp - defaults to current time */
  call_datetime?: string;
};

export interface ICallSolicitationUpdate {
  call_solicitation_id: string;
  outcome?: CallSolicitationOutcomeMap;
  notes?: string;
  save_note_to_profile?: boolean;
  /** When present alongside a rejection outcome set that on the opportunity expert */
  rejection_code?: RejectionCodesMap;
  honorarium?: { currency: string; quant?: number; qual?: number };
}

export interface ICallSolicitationUpdateReturn {
  call_solicitation: ICallSolicitation;
  expert_update?: Partial<Pick<IExpert, 'connectPhase' | 'rejection'>> & {
    expertId: string;
  };
  profile_update?: {
    expertProfileId: string;
    honorarium?: { currency: string; quant?: number; qual?: number };
  };
}
